import { Select, styled } from '@mui/material';
import { CoreBox } from '@youscience/core';

export const StyledSectionWrap = styled(CoreBox)(() => ({
  display: 'flex',
  gap: '1.5rem',
  flexDirection: 'column',
  backgroundColor: '#F9F9F9',
  padding: '2rem 2.5rem',
}));

export const StyledSortByWrap = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  minWidth: '325px',

  '& > h5:first-of-type': {
    fontSize: '1rem',
    marginLeft: '0.5rem',
    marginRight: '0.25rem',
  },
}));

export const StyledSortSelect = styled(Select)(({ theme }) => ({
  '.MuiOutlinedInput-input': {
    padding: '0.375rem',
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: 0,
  },

  '& > svg:first-of-type': {
    color: theme.palette.common.black,
  },
}));
